/**
 * @Copyright 2014-2017 DataVoke, Inc. All rights reserved.
 */
define(['require',
    '../appContext',
    'knockout',
    './dvFont'],
function (require, app, ko, dvfont) {
    "use strict";

    function HtmlElementStyle() {
        var self = {};

        self.dvFont = dvfont;

        self.cssList = ko.observableArray([]);
        self.top = ko.observable(0);
        self.left = ko.observable(0);
        self.width = ko.observable("100%");
        self.minWidth = ko.observable("10em");
        self.maxWidth = ko.observable("200%");
        self.height = ko.observable("100%");
        self.minHeight = ko.observable("7em");
        self.maxHeight = ko.observable("200%");
        self.foreColor = ko.observable("black");
        self.backColor = ko.observable("white");
        self.border = ko.observable("1px solid black");
        self.borderRadius = ko.observable("0px");
        self.zIndex = ko.observable("auto");
        self.font = ko.observable(new self.dvFont);

        self.cssName = ko.pureComputed(function () {
            var s = "";
            for (var i in self.cssList()) { s += self.cssList()[i] + " "; }
            return s;
        });

        self.clone = function () {
            var n = new HtmlElementStyle();

            n.cssList(self.cssList());
            n.top(self.top());
            n.left(self.left());
            n.width(self.width());
            n.minWidth(self.minWidth());
            n.maxWidth(self.maxWidth());
            n.height(self.height());
            n.minHeight(self.minHeight());
            n.maxHeight(self.maxHeight());
            n.foreColor(self.foreColor());
            n.backColor(self.backColor());
            n.border(self.border());
            n.borderRadius(self.borderRadius());
            n.zIndex(self.zIndex());

            n.font(self.font().clone());

            return n;
        }

        self.dispose = function () {
            self.cssList = null;
            self.top = null;
            self.left = null;
            self.width = null;
            self.minWidth = null;
            self.maxWidth = null;
            self.height = null;
            self.minHeight = null;
            self.maxHeight = null;
            self.foreColor = null;
            self.backColor = null;
            self.border = null;
            self.borderRadius = null;
            self.zIndex = null;
            self.font().dispose();
        }

        return self;
    }

    return HtmlElementStyle;
});
